import { useEffect, useState } from "react";
import { BASE_URL } from "../services/api";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup
} from "react-leaflet";

import { io } from "socket.io-client";

import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",

  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",

  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const socket = io(BASE_URL);

export default function MapPage() {
  const [drivers, setDrivers] = useState([]);

  useEffect(() => {

    socket.on("driverLocationUpdated", (data) => {

      setDrivers((prev) => {
        const exists = prev.find(
          (d) => d.id === data.id
        );

        if (exists) {
          return prev.map((d) =>
            d.id === data.id ? data : d
          );
        }

        return [...prev, data];
      });
    });

    return () => {
      socket.off("driverLocationUpdated");
    };

  }, []);

  return (
    <div>
      <h1 style={{ color: "#0B3C5D" }}>
        🗺️ Live Map Saint-Louis
      </h1>

      <MapContainer
        center={[16.0179, -16.4896]}
        zoom={13}
        style={{
          height: "80vh",
          width: "100%"
        }}
      >
        <TileLayer
          attribution="OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {drivers.map((d) => (
          <Marker
            key={d.id}
            position={[
              d.latitude,
              d.longitude
            ]}
          >
            <Popup>
              🚗 {d.name}
              <br />
              📞 {d.telephone}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}